module.exports = __webpack_public_path__ + "img/MapPicsBlackForest.a62492f2.webp";